import React from "react";
import { MEMBERS } from "../data/content";
import { SectionHeading } from "./Section";

export default function Band({ theme }) {
  const isSynth = theme === "synthwave";

  return (
    <section
      id="band"
      data-testid="band-section"
      className={`section-pad ${isSynth ? "bg-[#050510]" : "bg-[#12100e]"}`}
    >
      <div className="container-x">
        <SectionHeading
          theme={theme}
          kicker="Members"
          title={isSynth ? "The // Band" : "Meet The Band"}
          sub="Eight professional musicians who recreate the magic of Hall & Oates"
        />

        <div className="space-y-20 md:space-y-28">
          {MEMBERS.map((m, idx) => {
            const flipped = idx % 2 === 1;
            return (
              <div
                key={m.name}
                data-testid={`band-member-${idx}`}
                className={`grid grid-cols-12 gap-6 md:gap-10 items-center ${
                  flipped ? "md:[direction:rtl]" : ""
                }`}
              >
                <div className="col-span-12 md:col-span-5 [direction:ltr]">
                  {isSynth ? (
                    <div className="relative">
                      <div
                        className="absolute -inset-2"
                        style={{
                          background:
                            "linear-gradient(135deg,#00ffff,#ff00ff)",
                          filter: "blur(20px)",
                          opacity: 0.4,
                        }}
                      />
                      <div
                        className="relative aspect-[4/5] overflow-hidden border-2"
                        style={{ borderColor: "#ff00ff" }}
                      >
                        {m.image ? (
                          <>
                            <img
                              src={m.image}
                              alt={m.name}
                              className="w-full h-full object-cover"
                              style={{
                                filter:
                                  "saturate(1.3) contrast(1.05) hue-rotate(-10deg)",
                              }}
                            />
                            <div
                              className="absolute inset-0"
                              style={{
                                background:
                                  "linear-gradient(180deg, rgba(0,255,255,0.15) 0%, transparent 30%, rgba(255,0,255,0.25) 100%)",
                                mixBlendMode: "overlay",
                              }}
                            />
                          </>
                        ) : (
                          <div
                            className="w-full h-full flex items-center justify-center text-center px-4"
                            style={{
                              background:
                                "linear-gradient(180deg, #1a0632 0%, #050510 100%)",
                            }}
                          >
                            <div
                              className="font-display uppercase tracking-[0.3em] text-sm text-fuchsia-300"
                              style={{
                                textShadow: "0 0 12px rgba(255,0,255,0.55)",
                              }}
                            >
                              Photo
                              <br />
                              Coming
                              <br />
                              Soon
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ) : (
                    <div className="relative">
                      <div className="aspect-[4/5] overflow-hidden">
                        <img
                          src={m.image}
                          alt={m.name}
                          className="w-full h-full object-cover"
                          style={{
                            filter:
                              "sepia(0.55) contrast(1.1) brightness(0.85) saturate(0.8)",
                          }}
                        />
                      </div>
                      <div
                        className="absolute -bottom-4 -right-4 w-24 h-24 hidden md:flex items-center justify-center font-stamp text-xs text-[#12100e]"
                        style={{
                          background: "#d4af37",
                          transform: "rotate(8deg)",
                          textAlign: "center",
                          lineHeight: 1.2,
                          padding: "8px",
                        }}
                      >
                        OOT
                        <br />
                        '17
                      </div>
                    </div>
                  )}
                </div>

                <div className="col-span-12 md:col-span-7 [direction:ltr]">
                  <p
                    className={`text-xs uppercase tracking-[0.35em] mb-3 ${
                      isSynth ? "text-cyan-300" : "font-stamp text-[#c44900]"
                    }`}
                  >
                    #{String(idx + 1).padStart(2, "0")} ·{" "}
                    {isSynth ? "Member File" : "On Record"}
                  </p>
                  <h3
                    className={`font-display uppercase mb-3 ${
                      isSynth
                        ? "text-4xl md:text-5xl neon-gradient-text"
                        : "text-5xl md:text-6xl text-[#f4ebd8]"
                    }`}
                  >
                    {m.name}
                  </h3>
                  <p
                    className={`text-sm uppercase tracking-[0.25em] mb-6 ${
                      isSynth ? "text-fuchsia-400" : "text-[#d4af37]"
                    }`}
                  >
                    {m.role}
                  </p>
                  <div
                    className={`text-base md:text-lg leading-relaxed max-w-xl space-y-4 ${
                      isSynth ? "text-gray-300" : "text-[#a89f91]"
                    }`}
                  >
                    {m.bio
                      .split(/\n\n+/)
                      .filter(Boolean)
                      .map((para, i) => (
                        <p key={i}>{para}</p>
                      ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
